import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {iconList} from './ti-icon';

@Component({
  selector: 'ti-icon',
  templateUrl: './ti-icon.component.html',
  styleUrls: ['./ti-icon.component.scss'],
})
export class TiIconComponent implements OnInit {

  @Input() name: string;
  @Input() size = '24px';

  svg: SafeHtml;
  private readonly list: any;

  constructor(private sanitizer: DomSanitizer) {
    this.list = iconList;
  }

  ngOnInit() {
    this.svg = this.sanitizer.bypassSecurityTrustHtml(this.list[this.name]);
  }

}
